import { BaseModel, BaseModelKeys } from '../base.model';
import { SupportedCollectionsKeys } from './elastic-search';
import { IndexProperties } from './elastic-search.model';

export enum AgentTeamTransferKeys {
  mode = 'mode',
  originMgaId = 'originMgaId',
  targetMgaId = 'targetMgaId',
  hierarchyWasabiPath = 'hierarchyWasabiPath',
  changesWasabiPath = 'changesWasabiPath',
  involvedAgentsDbIds = 'involvedAgentsDbIds',
}
export class AgentTeamTransfer extends BaseModel {
  [AgentTeamTransferKeys.mode]: string;
  [AgentTeamTransferKeys.originMgaId]: string;
  [AgentTeamTransferKeys.targetMgaId]?: string;
  [AgentTeamTransferKeys.hierarchyWasabiPath]: string;
  [AgentTeamTransferKeys.changesWasabiPath]: string;
  [AgentTeamTransferKeys.involvedAgentsDbIds]: string[];
}

export const AgentTeamTransferMappingProperties: IndexProperties = {
  [BaseModelKeys.createdDate]: { type: 'date' },
  [BaseModelKeys.createdBy]: { type: 'keyword' },
  [BaseModelKeys.createdByEmail]: { type: 'keyword' },
  [BaseModelKeys.createdByAgentDbId]: { type: 'keyword' },
  [AgentTeamTransferKeys.originMgaId]: { type: 'keyword' },
  [AgentTeamTransferKeys.targetMgaId]: { type: 'keyword' },
  [AgentTeamTransferKeys.hierarchyWasabiPath]: { type: 'text' },
  [AgentTeamTransferKeys.changesWasabiPath]: { type: 'text' },
  [AgentTeamTransferKeys.involvedAgentsDbIds]: { type: 'keyword' },
};

export enum ShipDocumentToElasticKeys {
  indexName = 'indexName',
  documentData = 'documentData',
}

export interface ShipDocumentToElasticPayload<T = any> {
  [ShipDocumentToElasticKeys.indexName]: SupportedCollectionsKeys;
  [ShipDocumentToElasticKeys.documentData]: T;
}
